export class Categorie {
    public id: number;
    public nom: string;
    public type: string;

    constructor(tab: any = {}) {
      Object.assign(this, tab);
    }
}
